import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperiences} from "../../portfolio";
import {Fade} from "../../components/FadeReveal/FadeReveal";
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const { t } = useTranslation();
  const {isDark} = useContext(StyleContext);
  if (workExperiences.display) {
    return (
      <div id="experience">
        <Fade bottom duration={1000} distance="20px">
          <div className="experience-container" id="workExperience">
            <div>
              <h1 className="experience-heading">{t('experience.title')}</h1>
              <p className="experience-subtitle">{t('experience.subtitle')}</p>
              <div className="experience-cards-div">
                {workExperiences.experience.map((card, i) => {
                  // Get translated content based on company
                  let translatedDesc, translatedHeading, translatedBullets;
                  
                  if (card.company === "Joblogic") {
                    translatedDesc = t('experience.joblogic.desc');
                    translatedHeading = t('experience.joblogic.heading');
                    translatedBullets = [
                      t('experience.joblogic.point1'),
                      t('experience.joblogic.point2'),
                      t('experience.joblogic.point3'),
                      t('experience.joblogic.point4'),
                      t('experience.joblogic.point5'),
                      t('experience.joblogic.point6'),
                      "",
                      t('experience.joblogic.toolsTitle'),
                      "",
                      t('experience.joblogic.tools'),
                      t('experience.joblogic.expertise')
                    ];
                  } else if (card.company === "YumyApps") {
                    translatedDesc = t('experience.yumyapps.desc');
                    translatedHeading = t('experience.yumyapps.heading');
                    translatedBullets = [
                      t('experience.yumyapps.point1'),
                      t('experience.yumyapps.point2'),
                      t('experience.yumyapps.point3'),
                      t('experience.yumyapps.point4'),
                      t('experience.yumyapps.point5'),
                      t('experience.yumyapps.point6')
                    ];
                  } else if (card.company === "Vespert Tech") {
                    translatedDesc = t('experience.vespert.desc');
                    translatedHeading = t('experience.vespert.heading');
                    translatedBullets = [
                      t('experience.vespert.point1'),
                      t('experience.vespert.point2'),
                      t('experience.vespert.point3'),
                      t('experience.vespert.point4'),
                      t('experience.vespert.point5'),
                      t('experience.vespert.point6')
                    ];
                  } else {
                    // Fallback to original data
                    translatedDesc = card.desc;
                    translatedHeading = card.heading;
                    translatedBullets = card.descBullets;
                  }

                  return (
                    <ExperienceCard
                      key={i}
                      isDark={isDark}
                      cardInfo={{
                        company: card.company,
                        desc: translatedDesc,
                        date: card.date,
                        companylogo: card.companylogo,
                        role: card.role,
                        heading: translatedHeading,
                        descBullets: translatedBullets,
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
  return null;
}
